module.exports = __webpack_public_path__ + "static/media/right-arrow-circle.58085472.svg";